<script>
import modal from '@/components/view/modal'
import videoPlayer from '@/components/view/video-player'
export default {
  components: {
    'gp-modal': modal,
    'video-player': videoPlayer
  },
  data: () => ({
    globalFooter: null,
    globalNav: null
  }),
  computed: {
    videoId () {
      return this.$route.hash.replace('#', '')
    }
  },
  mounted () {
    this.globalFooter = document.querySelector('.global-footer')
    this.globalNav = document.querySelector('.global-nav')
  },
  methods: {
    beforeEnter () {
      this.globalFooter.style.display = 'none'
      setTimeout(() => {
        this.globalNav.style.position = 'fixed'
      }, 10)
    },
    afterEnter () {
      this.globalFooter.style.display = 'block'
      setTimeout(() => {
        this.$emit('scroll')
      }, 10)
    }
  }
}
</script>

<template>
  <div class="gp-news">
    <div class="page-background"></div>
    <header>
      <h1 class="page-title">NEWS</h1>
    </header>
    <div class="transition-container">
      <transition name="slide-in"
        @before-enter="beforeEnter"
        @after-enter="afterEnter"
      >
        <router-view :key="$route.path"></router-view>
      </transition>
    </div>
    <transition name="slide-up">
      <gp-modal v-if="videoId" :route="{name: 'news-article'}">
        <video-player :videoId="videoId" :route="{name: 'news-article'}"/>
      </gp-modal>
    </transition>
  </div>
</template>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/page/news/news.vue